<template>
  <div class="input-item">
    <ul class="input-item__list">
      <li>
        <div class="input-item__img">
          <img :src="item.image" :alt="item.name" />
        </div>
        <div class="input-item__name">{{ item.name }}</div>
      </li>
      <li>
        <span class="input-item__label">価格</span>
        <span class="input-item__data">¥{{ item.amount | addComma }}<small>(税込)</small></span>
      </li>
      <li>
        <span class="input-item__label">クーポンコード</span>
        <span class="input-item__">
          <input type="text" v-model="coupon" class="input-item__code">
          <div class="input-item__apply" @click="useCoupon">適用</div>
        </span>
      </li>
      <li v-show="showDiscount">
        <span class="input-item__label">割引金額</span>
        <span class="input-item__data--discount"><i>-</i>¥{{ discount | addComma }}</span>
      </li>
      <li>
        <span class="input-item__label">合計金額</span>
        <span class="input-item__data"><b>¥{{ price | addComma }}<small v-show="price > 0">(税込)</small></b></span>
      </li>
    </ul>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'AcademyInputItem',
  props: {
    item: Object,
    user: Object,
    price: Number,
  },
  data() {
    return {
      coupon: '',
      showDiscount: false,
      discount: 0,
    }
  },
  methods: {
    // クーポンを適用
    useCoupon() {
      if (this.coupon) {
        const url = '/api/academy/getcoupon'
        const param = { 'coupon_id': this.coupon, 'session_id': this.user.academySessionId, 'entry_number': this.user.entryNumber }
        const messageError = 'このクーポンはご利用になれません。クーポンコードが正しくないか、不正な処理がおこなわれました。'
        const messageParam = { duration: 5000, showClose: true }
        axios.post(url, param).then(res => {
          if (res.data.response === 'OK') {
            this.$message({ message: 'クーポンが適用されました', type: 'success', ...messageParam })
            this.discount = Math.min(res.data.discount_price, this.item.amount)
            this.showDiscount = true
            this.$emit('use', { code: this.coupon, discount: this.discount, webcvs: res.data.WebcvsInformalPaymentArray })
          } else {
            this.$message({ message: messageError, type: 'warning', ...messageParam })
          }
        }).catch(error => {
          this.$message({ message: messageError, type: 'warning', ...messageParam })
        })
      }
    }
  },
}
</script>

<style lang="scss" scope>
@import '../../../../../sass/commons/commonVariables.scss';

.input-item {
  &__list {
    padding: 0;
    margin: 0 auto;
    > li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-top: 1px solid #EDEDED;
      padding: 15px;
      &:first-child {
        border: none;
      }
    }
    @include mq('w580') {
      max-width: 360px;
      > li {
        padding: 15px 0;
      }
    }
  }
  &__img {
    flex: 0 0 37.97%;
    max-width: 131px;
    margin-right: 10px;
    > img {
      max-width: 100%;
      vertical-align: middle;
    }
  }
  &__name {
    flex: 1 1 auto;
    font-weight: bold;
    font-size: 13px;
    line-height: 16px;
    text-align: justify;
    align-self: flex-start;
  }
  &__label {
  }
  &__data {
    font-size: 18px;
    line-height: 1;
    color: $academy_purple;
    small {
      font-size: 10px;
    }
    &--discount {
      @extend .input-item__data;
      color: #EB5757;
      font-weight: bold;
      > i {
        margin-right: 2px;
      }
    }
  }
  &__code {
    appearance: none;
    box-sizing: none;
    outline: none;
    background: #FFFFFF;
    border: 1px solid $academy_purple;
    border-radius: 2px;
    font-size: 14px;
    color: #676767;
    padding: 0 5px;
    height: 26px;
    line-height: 26px;
    width: 120px;
    text-align: right;
  }
  &__apply {
    display: inline-block;
    font-size: 13px;
    color: $academy_purple;
    margin-left: 1px;
    padding: 0 16px;
    height: 26px;
    line-height: 26px;
    vertical-align: bottom;
    background: #fff;
    border: 1px solid $academy_purple;
    border-radius: 5px;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Academy/partials/InputItem.vue